import { configureStore } from '@reduxjs/toolkit';
import authSlice from './authSlice';
import sidebarSlice from './sidebarSlice';
import viewSlice from './viewSlice';

const store = configureStore({
    reducer: {
        auth: authSlice.reducer,
        sidebar: sidebarSlice.reducer,
        view: viewSlice.reducer
    }
});

export default store;